import { useDashboardData } from '@/hooks/useDashboardData'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

const GoalTrendChart = () => {
  const { data, isLoading, error } = useDashboardData()

  if (isLoading) {
    return (
      <div className="h-48 lg:h-64 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
      </div>
    )
  }

  if (error || !data) {
    return (
      <div className="h-48 lg:h-64 flex items-center justify-center text-red-600">
        データの読み込みに失敗しました
      </div>
    )
  }

  const { goalsPerTournament } = data.charts

  // デバッグ用ログ
  // console.log('Goal trend data:', goalsPerTournament)
  // console.log('Full data structure:', data)
  // console.log('Data type:', typeof goalsPerTournament)
  // console.log('Is array:', Array.isArray(goalsPerTournament))
  // console.log('Length:', goalsPerTournament?.length)

  // データが空の場合は空の配列を返す
  if (!goalsPerTournament || goalsPerTournament.length === 0) {
    return (
      <div className="h-48 lg:h-64 flex items-center justify-center text-gray-500">
        <div>
          <p>データがありません</p>
          {/* <p className="text-xs mt-2">charts: {JSON.stringify(data.charts)}</p> */}
        </div>
      </div>
    )
  }

  return (
    <div className="w-full h-64 sm:h-72 md:h-80 lg:h-96 overflow-x-auto">
      <div className="min-w-[400px] h-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={goalsPerTournament} margin={{ left: 0, right: 0, top: 10, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="year" tick={{ fontSize: 12 }} />
                         <YAxis tick={{ fontSize: 12 }} width={40} />
            <Tooltip />
            <Line 
              type="monotone" 
              dataKey="goals" 
              stroke="#8b5cf6" 
              strokeWidth={2}
              dot={{ fill: '#8b5cf6', strokeWidth: 2, r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default GoalTrendChart
